import { AdjustedCargoTemperature } from 'src/types/ViewModel/Stowage/AdjustedCargoTemperature';

export const createFullTemperatureChangeData = (adjustedCargoTemperature: AdjustedCargoTemperature): Partial<AdjustedCargoTemperature> => ({
    cargoGuid: adjustedCargoTemperature.cargoGuid,
    tankId: adjustedCargoTemperature.tankId,
    temperature: adjustedCargoTemperature.temperature,
});

export const createTemperatureOnlyChangeData = (temperature: number): Partial<AdjustedCargoTemperature> => ({
    temperature,
});
